import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { ActivityRepository } from '@/store/activity-state/activity-state.repository';

interface IgetActivityUpdateDrawerObjectProps {
  store?: ActivityRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getActivityUpdateDrawerObject = ({ store, formObject, toggleVisibility, action }: IgetActivityUpdateDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.activity.update.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.activity.update.update',
        onClick: () => action?.(),
        disabled: store?.getObservable<boolean>('isEqual'),
      },
      {
        label: 'settings.activity.update.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
